<it-column padding="0" gap="0" flex="1" minHeight="0">
    <it-column
        padding="1rem 1.5rem"
        class="dialog-header"
        axisY="center"
        minHeight="90px"
    >
        <it-row padding="0" gap="1rem" axisX="space-between" axisY="center">
            <it-title
                weight="700"
                fontSize="1.5rem"
                [color]="ColorEnum.NEUTRAL_50"
            >
                {{ header }}
            </it-title>

            <it-button
                testId="confirm-dialog-close"
                severity="primary"
                variant="icon-only"
                [text]="true"
                [icon]="IconEnum.TIMES"
                [backgroundColor]="ColorEnum.WHITE_OVERLAY_20"
                [hoverBackgroundColor]="ColorEnum.WHITE_OVERLAY_30"
                [color]="ColorEnum.NEUTRAL_50"
                (clicked)="cancelled.emit()"
            />
        </it-row>
    </it-column>

    <it-column [padding]="contentPadding" [scroll]="true">
        <ng-content></ng-content>
    </it-column>

    <it-column padding="1rem 1.5rem" class="dialog-footer">
        <it-row padding="0" axisY="center" axisX="flex-end" gap="1rem">
            <ng-content select="[footerLeft]"></ng-content>

            <it-row padding="0" axisY="center" axisX="flex-end" gap="1rem">
                @if (showDeleteButton) {
                    <it-button
                        severity="danger"
                        [text]="true"
                        [loading]="deleteLoading"
                        [label]="deleteButtonLabel"
                        testId="confirm-dialog-delete"
                        (clicked)="deleted.emit()"
                    />
                }

                <it-row padding="0" axisY="center" axisX="flex-end" gap="1rem">
                    @if (showCancelButton) {
                        <it-button
                            [text]="true"
                            [disabled]="loading"
                            [color]="ColorEnum.NEUTRAL_700"
                            (clicked)="cancelled.emit()"
                            i18n-label="@@glossary.cancel"
                            label="Cancel"
                            severity="secondary"
                            testId="confirm-dialog-cancel"
                        ></it-button>
                    }

                    <it-button
                        [disabled]="disableAccept"
                        [loading]="loading"
                        (clicked)="accepted.emit()"
                        [label]="confirmButtonLabel"
                        [severity]="acceptButtonSeverity"
                        testId="confirm-dialog-ok"
                    ></it-button>
                </it-row>
            </it-row>
        </it-row>
    </it-column>
</it-column>
